import React from "react";
import { connect } from "react-redux";

//import { addView } from "../../actions/postActions";

const HotCities = (props) => {
  const { hotCitie } = props;

  const person = { last: "svekis", num: "001" };
  console.log("val_person", person);
  console.log("val_brussels");

  return (
    <div className="container mt-0" style={{ paddingTop: "0px" }}>
      <p className="text-left text-white">
        <small>
          <em> {hotCitie.ll_name}</em>{" "}
          <span className="badge bg-white text-dark"> in</span>
          <span style={{ cursor: "pointer" }}>
            <a
              href={`https://spotahome.sjv.io/c/2913702/870243/12133?url=${hotCitie.link}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="badge badge-sm  bg-info text-white badge-outline-info m-1">
                {hotCitie.neigbourhood}
                {""}
                <i className="fa fa-link text-white " />
              </span>
            </a>
          </span>
          <span className="badge bg-white text-dark">
            {" "}
            <em> {hotCitie.price}€</em>{" "}
          </span>
        </small>
      </p>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(HotCities);
